export const environment = {
  production: false,
  baseUrl: 'https://staging-ims-api.lnps.streamamg.com/staging',
  wpContractUrl: 'https://staging-bbcldrs.streamamg.com/wp-json/samg/v1/contracts',
  wpAuth: 'Basic cm9fYXBpdXNlcjpvZzBuIEZRRjkgdDRwcCBYSnN4IHVhM1UgUE5jSg==',
  newshubContentAPIUrl: 'https://api.newshub.bbc.co.uk/v1/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts